'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var card = require('./card.js');
var layerStyles = {
  card: card["default"]
};
exports["default"] = layerStyles;